export function calculateTimeDifference(timeString: string): string {
  const endTime = new Date(timeString);
  const now = new Date();

  // 计算时间差 (毫秒)
  let diffInMs = endTime.getTime() - now.getTime();

  if (diffInMs <= 0) return '已过期';

  // 转换为天数
  const days = Math.floor(diffInMs / (1000 * 60 * 60 * 24));
  diffInMs -= days * (1000 * 60 * 60 * 24);

  // 转换为小时数
  const hours = Math.floor(diffInMs / (1000 * 60 * 60));

  // 简化假设一个月大约有30天
  const months = Math.floor(days / 30);
  const remainingDays = days % 30;

  let result = '';

  if (months > 0) {
    result += `${months} 月 `;
  }
  if (remainingDays > 0) {
    result += `${remainingDays} 天 `;
  }
  if (hours > 0) {
    result += `${hours} 小时`;
  }

  return result.trim(); // 去除末尾多余的空格
}

// 示例用法
// const vipEndTime = "2023-12-31 23:59:59";
// console.log(calculateTimeDifference(vipEndTime)); // 输出类似：'X 月 X 天 X 小时'

export function formatTimestamp(ms: string) {
  const date = new Date(Number(ms));
  const pad = (n: any) => String(n).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} `
    + `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

